<template>
  <CRow>
    <CCol col="12" lg="12">
      <CCard no-header>
        <CCardBody>
      <form
      @submit="saveData"
      method="post"
      >
          <h3 v-if="isEditing">
            {{ $t('button.edit') }} {{ $t('orders.label') }}
          </h3>
          <h3 v-else>{{ $t('button.create') }} {{ $t('orders.label') }}</h3>
            <div class="row">
              <div class="col-4">
                <div class="input-group mb-3">
                  <input type="text" v-model="phoneNumber" class="form-control" placeholder="Phone Number" aria-label="Buscar" aria-describedby="search">
                  <div class="input-group-append">
                    <button class="btn btn-primary" type="button" @click="searchClient">
                      <CIcon :content="$options.searchIcon" /> {{ $t('search') }} {{ $t('clients.label') }}
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-4">
                <CInput :label="$t('fields.name')" type="text" placeholder="Ej: Juan Perez" v-model="client.name" :disabled="disabledImputs" required></CInput>
              </div>
              <div class="col-4">
                <CInput :label="$t('fields.address')" type="text" placeholder="Ej: 27 de Febrero" v-model="client.address" :disabled="disabledImputs" required></CInput>
              </div>
              <div class="col-4">
                <CInput :label="$t('fields.address2')" type="text" placeholder="Ej: " v-model="client.address2" :disabled="disabledImputs" required></CInput>
              </div>
            </div>
            
            <div class="row">
              <div class="col-4">
                <CInput :label="$t('fields.phone')" type="text" placeholder="Ej: 809-111-1111" v-model="client.phone" :disabled="disabledImputs" required></CInput>
              </div>
              <div class="col-4">
                <CInput :label="$t('fields.phone2')" placeholder="Ej: 809-111-1111" v-model="client.phone2" :disabled="disabledImputs"></CInput>
              </div>
              <div class="col-4">
                <CInput :label="$t('fields.state')" type="text" placeholder="Ej: Distrito Nacional" v-model="client.state" :disabled="disabledImputs" required></CInput>
              </div>
            </div>
            
            <div class="row">
              <div class="col-4">
                <CInput :label="$t('fields.city')" type="text" placeholder="Ej: Santo Domingo" v-model="client.city" :disabled="disabledImputs" required></CInput>
              </div>
              <div class="col-4">
                <CInput :label="$t('fields.zipcode')" type="text" placeholder="Ej: 11111" v-model="client.zipcode" :disabled="disabledImputs" required></CInput>
              </div>
              <div class="col-4">
                <CInput :label="$t('fields.order_date')" type="date" v-model="order.order_date" required></CInput>
              </div>
            </div>
            <div class="row">
              <div class="col-4">
                <CSelect 
                :label="$t('fields.payment_type')"  
                :value.sync="order.payment_type_id" 
                :plain="true" 
                :options="paymentTypes"
                :placeholder="$t('fields.payment_type_placeholder')"
                required>
                </CSelect>
              </div>
              <div class="col-4">
                <CSelect 
                :label="$t('fields.driver')" 
                :value.sync="order.driver_id" 
                :plain="true" 
                :options="driverSelect"
                :placeholder="$t('fields.driver_placeholder')"
                required>
                </CSelect>
              </div>
              <div class="col-4">
                <CTextarea :label="$t('comment')" :placeholder="$t('fields.comment_placeholder')" v-model="order.comment"></CTextarea>
              </div>
            </div>
            <div class="row">
              <div class="col-4">
                <CInputCheckbox :label="$t('pay')"  :checked.sync="order.pay" ></CInputCheckbox>
                <br>
              </div>
            </div>
            <!-- handle products -->
            <div class="row">
              <div class="col-6">
                <div class="pb-3">
                  <CButton color="primary" @click="showModal = true">
                    <CIcon :content="$options.cartIcon" /> {{ $t('button.delivery_type') }}
                  </CButton>
                </div>
                <CDataTable
                  class="mb-0 table-outline"
                  :items="deliveryTypes"
                  :fields="fields"
                  head-color="light"
                  hover
                  no-sorting
                  >
                  <td slot="price" slot-scope="{item}">
                    ${{ item.price | toCurrency }}
                  </td>
                  <template #options="{item}">
                    <CButton color="primary" @click="showEditDelivery(item.id)"><CIcon :content="$options.editIcon" /></CButton>
                    <CButton color="primary" @click="deleteDeliveryType(item.id)"><CIcon :content="$options.deleteIcon" /></CButton>
                  </template>
                </CDataTable>
              </div>
            </div>
            <div class="row mt-5">
              <div class="col-6">
                <label>{{ $t('fields.document') }} </label>
                <div class="d-flex flex-row align-items-end" v-if="imageUrl !== ''">
                  <div class="p-2">
                    <img :src="imageUrl">
                  </div>
                  <div class="p-2">
                    <CButton color="primary" @click="deleteImage()">
                      <CIcon :content="$options.deleteIcon" />
                    </CButton>
                  </div>
                </div>
                <CInputFile
                    type="file"
                    v-on:change="handleImage"
                    placeholder="New file"
                    ref="documentImage"
                />
              </div>
            </div>

            <div class="row pt-3 pb-3">
              <div class="col-12">
                <h5>{{ $t('fields.attended_by') }}: {{ userName }}</h5>
              </div>
            </div>

          <CButton color="success" type="submit">
            <template v-if="isEditing"><CIcon :content="$options.updateIcon" /> {{ $t('button.update') }}</template>
            <template v-else><CIcon :content="$options.addIcon" /> {{ $t('button.create') }}</template>
            </CButton>
          <CButton color="primary" @click="goBack"><CIcon :content="$options.backIcon" /> {{ $t('button.back') }}</CButton>
          </form>
        </CCardBody>
      </CCard>
    </CCol>
    <CModal :title="$t('button.delivery_type')" color="success" :show.sync="showModal">
      <div class="row">
        <div class="col-4">
          <CSelect 
          :label="$t('fields.delivery_type')" 
          :value.sync="delivery_type.id" 
          :plain="true" 
          :options="productSelect"
          :placeholder="$t('fields.delivery_type_placeholder')"
          @update:value="productSelected">
          </CSelect>
        </div>
        <div class="col-4">
          <CInput :label="$t('fields.bottles_quantity')"  type="text" placeholder="Ej: 10" v-model="delivery_type.quantity" @update:value="quantityChanged"></CInput>
        </div>
        <div class="col-4">
          <CInput 
          :label="$t('fields.price')" 
          type="text"
          prepend="$"
          placeholder="Ej: 100" 
          v-model="delivery_type.price">
          </CInput>
        </div>
      </div>
      <div slot="footer">
        <template v-if="isEditingDelivery">
          <CButton color="success" @click="editDelivery()">Edit</CButton>
        </template>
        <template v-else>
          <CButton color="success" @click="addDelivery()">Add</CButton>
        </template>
        <CButton color="danger" @click="cancelDelivery()">Cancel</CButton>
      </div>
    </CModal>
  </CRow>
</template>

<script>
import Vue from 'vue';
import { mapState } from 'vuex';
import axios from 'axios';
import formMixin from '../../mixins/form';
import localeMixin from '../../mixins/locale'; // Order matters, mixin first then i18n.
import i18n from "../../i18n";
import TableOrder from "./TableOrder";
import { cilMagnifyingGlass, cilPlus, cilSync, cilArrowLeft, cilCart, cilPencil, cilBan } from '@coreui/icons';

Vue.filter('toCurrency', function (value) {
  return value.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
});

export default {
  name: 'FormOrder',
  mixins: [formMixin, localeMixin],
  searchIcon: cilMagnifyingGlass,
  addIcon: cilPlus,
  editIcon: cilPencil,
  deleteIcon: cilBan,
  updateIcon: cilSync,
  backIcon: cilArrowLeft,
  cartIcon: cilCart,
  data() {
    return {
        disabledImputs: false,
        client: {
          id: '',
          name: '',
          address: '',
          address2: '',
          phone: '',
          phone2: '',
          state: '',
          city: '',
          zipcode: '',
        },
        tempClient: {
          name: '',
          address: '',
          address2: '',
          phone: '',
          phone2: '',
          state: '',
          city: '',
          zipcode: '',
        },
        order: {
          client_id: '',
          quantity: 0,
          product_id: '',
          total: 0,
          payment_type_id: '',
          driver_id: '',
          document: '',
          order_date: '',
          delivery_types: [],
          comment: '',
          pay: false,
          newImage: null
        },
        imageUrl: '',
        delivery_type: {
          id: '',
          quantity: 0,
          price: 0
        },
        temp_delivery_type: {
          id: '',
          quantity: 0,
          price: 0
        },
        products: [],
        productSelect: [],
        paymentTypes: [],
        driverSelect: [],
        phoneNumber: '',
        userName: '',
        downloadFileName: '',
        modal: {
          deleteFile: false,
          client: false
        },
        deleteFileModal: false,
        moveObjectName: '',
        tableInstance: null,
        showModal: false,
        deliveryTypes: [],
        isEditingDelivery: false,
        fields: [
          { key: 'name', label: i18n.t('fields.delivery_type') },
          { key: 'quantity', label: i18n.t('fields.bottles_quantity') },
          { key: 'price', label: i18n.t('fields.price') },
          { key: 'options', label: i18n.t('button.options')  }
        ]
    }
  },
  computed: {
     ...mapState({
      currentUser: state => state.currentUser,
    })
  },
  mounted() {
    this.getProducts();
    this.getPaymentTypes();
    this.getDrivers();
    if (this.isEditing) {
      this.getOrder();
    } else {
      this.$nextTick(() => {
        this.userName = this.currentUser.userName;
      });
    }
  },
  methods: {
      showAlertError() {
          if (this.message != "") {
              this.$swal({
                  title: i18n.t('modal.title'),
                  text: this.message,
                  icon: 'warning',
                  showCancelButton: true,
                  cancelButtonColor: '#d33',
              });
          } else {
              this.$swal({
                  title: i18n.t('modal.title'),
                  text: i18n.t('modal.body'),
                  icon: 'warning',
                  showCancelButton: true,
                  cancelButtonColor: '#d33',
              });
          }
      },
    goBack() {
        this.$router.push({ name: "Orders" });
    },
    saveData(e) {
        e.preventDefault();
        const data = this.order;
        this.$emit("saved", data);
        let url = `/api/orders`;
        let sendRequest = null;

        if (this.isEditing) {
            url = url + "/" + this.$route.params.id + '?token=' + localStorage.getItem("api_token");
            sendRequest = async() => {
                try {
                const response = await axios.put(url, data)
                    if (response.data.status === "success") {
                        this.showAlert();
                    }
                } catch (error) {
                    if(error.response.data.message == 'The given data was invalid.'){
                        this.message = '';
                        for (let key in error.response.data.errors) {
                            if (error.response.data.errors.hasOwnProperty(key)) {
                                this.message += error.response.data.errors[key][0] + '  ';
                            }
                        }
                        this.showAlertError();
                    } else{
                        console.log('error1');
                        console.log(error);
                        this.showAlertError();
                    }
                }
            };
        } else {
            url = url + '?token=' + localStorage.getItem("api_token");
            sendRequest = async() => {
                try {
                    const response = await axios.post(url, data);
                    if (response.data.status === "success") {
                        this.message = 'Successfully create order.';
                        this.showAlert();
                    }
                    // console.log(response.data);
                } catch (error) {
                    if(error.response.data.message == 'The given data was invalid.'){
                        this.message = '';
                        for (let key in error.response.data.errors) {
                            if (error.response.data.errors.hasOwnProperty(key)) {
                                this.message += error.response.data.errors[key][0] + '  ';
                            }
                        }
                        console.log(this.message);
                        this.showAlertError();
                    } else{
                        console.log(error);
                        this.showAlertError(); 
                    }
                }
            };
        }
        sendRequest();
        return data;
    },
    showAlert () {
      if (this.isEditing) {
        this.$swal(
          i18n.t('orders.modal.updated_label'),
          i18n.t('orders.modal.updated_body'),
          'success'
        ).then(result => {
          // this.goBack();
        });
      } else {
        this.$swal(
          i18n.t('orders.modal.created_label'),
          i18n.t('orders.modal.created_body'),
          'success'
        ).then(result => {
          this.goBack();
        });
      }
    },
    getProducts() {
      axios.get('/api/products?token=' + localStorage.getItem('api_token'))
      .then(response => {
        const data = response.data;
        // TODO: this is temporary
        // this.products = data;
        this.products = data.products;

        // data.forEach(elem => {
        data.products.forEach(elem => {
          this.productSelect.push({
            label: elem.name,
            value: elem.id
          });
        });
      }).catch(error => {
        console.log(error);
        this.showAlertError();
      });

    },
    getPaymentTypes() {
      axios.get('/api/payment-types?token=' + localStorage.getItem('api_token'))
      .then(response => {
        const data = response.data;
        data.forEach(elem => {
          this.paymentTypes.push({
            label: elem.name,
            value: elem.id
          });
        });

        if (!this.isEditing) {
          this.order.payment_type_id = this.paymentTypes.find(payment => payment.label === "Pendiente").value;
        }
      })
      .catch(error => {
        console.log(error);
        this.showAlertError();
      });
    },
    getDrivers() {
      axios.get('/api/drivers?token=' + localStorage.getItem('api_token'))
      .then(response => {
        const data = response.data;
        data.forEach(elem => {
          this.driverSelect.push({
            label: elem.name,
            value: elem.id
          });
        });
      })
      .catch(error => {
        console.log(error);
        this.showAlertError();
      });
    },
    productSelected() {
      const product = this.products.find(p => p.id === this.delivery_type.id);
      // console.log(product.price);
      this.delivery_type.price = this.delivery_type.quantity === '' ? product.price : this.multiplyPrice(product.price,  this.delivery_type.quantity);
    },
    quantityChanged() {
      if (this.delivery_type.id !== '') {
        const product = this.products.find(p => p.id === this.delivery_type.id);
        this.delivery_type.price = this.delivery_type.quantity === '' ? product.price : this.multiplyPrice(product.price,  this.delivery_type.quantity);
      }
    },
    multiplyPrice(price, quantity) {
      return Number.parseFloat((price * quantity)).toFixed(2);
    },
    searchClient() {
      if (this.phoneNumber !== '') {
        // serch client by phone
        axios.get('/api/clients/phone/' + this.phoneNumber + '?token=' + localStorage.getItem('api_token'))
        .then(response => {
          const data = response.data;
          if (data) {
              if (data.client) {
                  this.order.client_id = data.client.id;
                if (data.client.status === 0) {
                  // this.modal.client = true;
                  this.tempClient = data.client;
                  this.$swal({
                    title: i18n.t('orders.modal.inactive.title'),
                    text: i18n.t('orders.modal.inactive.body'),
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: i18n.t('button.accept')
                  }).then(result => {
                    if (result.value) {
                      this.client = this.tempClient;
                      this.activateClient();
                    }
                  });
                  return;
                }
                if (data.orders) {
                  this.tempClient = data.client;
                  this.$swal({
                    title: data.pending 
                    ? i18n.t('orders.modal.pending.title') 
                    : i18n.t('orders.modal.credit.body'),
                    html: '<div id="pending-orders"></div>',
                    icon: 'warning',
                    showCancelButton: true,
                    showConfirmButton: data.credit,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: i18n.t('button.accept'),
                    onBeforeOpen: () => {
                      const msg = data.pending 
                      ? i18n.t('orders.modal.pending.body') 
                      : i18n.t('orders.modal.credit.body');
                      this.mountTable(data.orders, msg);
                    }
                  }).then(result => {
                    if (result.value) {
                      this.client = this.tempClient;
                      this.destroyTable();
                    } else {
                      this.destroyTable();
                    }
                  });
                  return;
                }
                this.client = data.client;
                this.disabledImputs = true;
              } else {
                  this.$swal({
                    title: i18n.t('orders.modal.client.title'),
                    text: i18n.t('orders.modal.client.body'),
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: i18n.t('button.accept')
                  }).then(result => {
                    if (result.value) {
                        this.$router.push({ name: "CreateClient" });
                    }
                  });
              }
          }
        }).catch(error => {
          console.log(error);
            this.showAlertError();
        });
      }
    },
    activateClient() {
      const url = '/api/clients/activate/'+ this.client.id + '?token=' + localStorage.getItem("api_token");
      this.client.status = 1;
      const data = this.client;
      axios.put(url, data)
      .then(result => {

      }).catch(error => {
        console.log(error);
        this.showAlertError();
      });
    },
    handleImage(event) {
		let reader = new FileReader();
		let file = event[0];

		if(file) {
			reader.onloadend = () => {
                this.imageUrl = reader.result;
                this.order.newImage = reader.result;
			}
			reader.readAsDataURL(file)
		} else {
            this.imageUrl = '';
		}
	},
    deleteImage() {
      // we need to delete the image by filename
      // const id = this.$route.params.id;
      const fileName = this.order.document;
      const data = { filePath: fileName };
      const token = localStorage.getItem("api_token")
      axios.post('/api/orders/file/delete?token='+token, data)
      .then(response => {
        const data = response.data;
        if (data.status === 'success') {
          this.imageUrl = '';
          this.order.document = '';
          this.$refs.documentImage.$el.firstElementChild.value = '';
        }
      }).catch(error => {
        console.log(error);
      });
    },
    downloadFile(id, name){
        let self = this
        this.downloadFileName = name
        axios({
            method: 'get',
            url: '/api/media/file/download?thisFolder=' + self.thisFolder + '&id=' + id + '&token=' + localStorage.getItem("api_token"),
            responseType: 'arraybuffer'
        })
        .then(function(response){
            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', self.downloadFileName)
            document.body.appendChild(link)
            link.click()
        })
        .catch(function(error){
            console.log(error)
            self.showAlertError();
        });
    },
    openDeleteDialog(id, type, name){
        this.moveObjectName = name
        this.elementId = id
        if(type == 'folder'){
            this.deleteFolderModal = true
        }else{
            this.deleteFileModal = true
        }
    },
    deleteFile(){
      const id = this.$route.params.id;
      axios.post('/api/orders/file/delete/'+id+'?token=' + localStorage.getItem("api_token"))
      .then(response => {
        const data = response.data;
        if (data.status === 'success') {
          this.productUrl = '';
        }
      }).catch(error => {
        console.log(error);
      });
    },
    getOrder() {
      const id = this.$route.params.id;
      const token = this.token === null ? localStorage.getItem('api_token') : this.token;
      axios.get('/api/orders/' + id + '?token=' + localStorage.getItem("api_token"))
      .then(response => {
        const data = response.data;
        if (data) {
          this.order.client_id = data.client_id;
          this.order.pay = data.pay;
          this.order.driver_id = data.driver_id;
          this.order.product_id = data.product_id;
          this.order.quantity = data.quantity;
          this.order.total = data.total;
          this.order.comment = data.comment;
          this.order.payment_type_id = data.payment_type_id;
          this.order.order_date = data.order_date;
          this.order.delivery_types = data.delivery_types;
          this.order.document = data.document;
          this.imageUrl = data.document;
          this.deliveryTypes = data.delivery_types;
          this.userName = data.user;
          
          // client info
          this.client.name = data.name;
          this.client.address = data.address;
          this.client.address2 = data.address2;
          this.client.city = data.city;
          this.client.state = data.state;
          this.client.zipcode = data.zipcode;
          this.client.phone = data.phone;
          this.client.phone2 = data.phone2;
          this.disabledImputs = true;
        }
      }).catch(error => {
        console.log(error);
          this.showAlertError();
      });
    },
    addDelivery() {
      const current_item = this.delivery_type;
      const check_item = this.deliveryTypes.find(d => d.id == current_item.id);

      if (check_item) {
        this.showModal = false;
        if (this.isEditingDelivery) {
          this.isEditingDelivery = false;
        }
        
        return;
      }

      this.deliveryTypes.push({
        id: this.delivery_type.id,
        name: this.products.find(p => p.id === this.delivery_type.id).name,
        price: this.delivery_type.price,
        quantity: this.delivery_type.quantity
      });

      // this.order.quantity += parseInt(this.delivery_type.quantity);
      // this.order.total += parseFloat(this.delivery_type.price);
      this.order.delivery_types = this.deliveryTypes;
      // sum all delivery types
      this.order.quantity = 0;
      this.order.total = 0;
      this.deliveryTypes.forEach(delivery => {
        this.order.quantity += parseInt(delivery.quantity);
        this.order.total += parseFloat(delivery.price);
      });

      // This is used to hold the current delivery_type item.
      this.delivery_type = {
        id: '',
        quantity: '',
        price: ''
      }

      console.log(this.order);

      // hide modal
      this.showModal = false;
      if (this.isEditingDelivery) {
        this.isEditingDelivery = false;
      }
    },
    editDelivery() {
      const old_item = this.deliveryTypes.find(d => d.id === this.temp_delivery_type.id);
      old_item.quantity = this.temp_delivery_type.quantity;
      old_item.price = this.temp_delivery_type.price;
      // substract data from old item
      // this.order.quantity -= parseInt(old_item.quantity);
      // this.order.total -= parseFloat(old_item.price);
      // remove the old item, them add the new one to deliveryTypes array
      this.deliveryTypes = this.deliveryTypes.filter(d => d.id !== old_item.id);
      // clear temp_delivery_type
      this.temp_delivery_type = {
        id: '',
        quantity: 0,
        price: 0
      };

      this.addDelivery();
    },
    showEditDelivery(id) {
      const item = this.deliveryTypes.find(d => d.id === id);
      this.delivery_type.id = item.id;
      this.delivery_type.quantity = item.quantity;
      this.delivery_type.price = item.price;
      // this holds the old item in case of change of delivery_type
      this.temp_delivery_type = {
        id: item.id,
        quantity: item.quantity,
        price: item.price
      }
      this.isEditingDelivery = true;
      this.showModal = true;
    },
    cancelDelivery() {
      this.showModal = false;
      this.isEditingDelivery = false;
      this.temp_delivery_type = {
        id: '',
        quantity: 0,
        price: 0
      };

      this.delivery_type = {
        id: '',
        quantity: 0,
        price: 0
      };
    },
    mountTable(orders, message) {
      let ComponentClass = Vue.extend(TableOrder);
      this.tableInstance = new ComponentClass({
        propsData: {
          table_labels: {
            order: i18n.t('fields.order_date'),
            quantity: i18n.t('fields.quantity'),
            amount: i18n.t('fields.amount')
          },
          body: message
        }
      });
      this.tableInstance.$mount();
      this.tableInstance.initTable(orders);
      document.getElementById('pending-orders').appendChild(this.tableInstance.$el);
    },
    destroyTable() {
      this.tableInstance.$destroy();
      this.tableInstance = null;
    },
    deleteDeliveryType(id) {
      this.order.delivery_types = this.order.delivery_types.filter(d => d.id !== id);
      this.deliveryTypes = this.deliveryTypes.filter(d => d.id !== id);
    }
  }
}

</script>

<style scoped>
.card-body img {
  width: 200px;
  height: 200px
}
</style>
